import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudTypographyModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { NotificationsErrorComponent } from './notifications-error.component';

@NgModule({
	declarations: [NotificationsErrorComponent],
	exports: [NotificationsErrorComponent],
	providers: [],
	imports: [CommonModule, TranslateModule, FreudTypographyModule],
})
export class NotificationsErrorModule {}
